import React from "react";
import FooterSection from "../../../components/sections/FooterSection";
import { useTranslation } from "react-i18next";
import BigTinyIntroSection from "../../../components/sections/BigTinyIntroSection";
import VisaServicesPromotion from "../../../components/sections/VisaServicesPromotion";
import OnePlusTwoGallery from "../../../components/sections/OnePlusTwoGallery";
import HeroSection from "../../../components/sections/HeroSection";

function OpenCompanyVisaPage(props) {

    var { t } = useTranslation();

    return (
        <>
            <HeroSection
                isExpectingAnimations={true}
                title="Open a Company in Kazakhstan with Jai International Today!"
                paragraph="Jai International assists investors and entrepreneurs in establishing their business presence in Kazakhstan. Our experts manage every step — from investor visa processing to company or branch registration — ensuring full legal compliance and operational readiness."
                callToAction="Open Company"
                backgroundImageUrl="/imgvideo/astana_hd.jpg"
                onCallToActionClick={() => window.open("https://wa.me/77750912804?text=Hello%2C%20I%20want%20to%20study%20in%20Kazakhstan", "_blank")}
                callToActionButtonClass="uk-button-jai"
            />
            <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                <section className="uk-grid-large uk-child-width-1-2@s uk-flex-middle" data-uk-grid>
                    <div>
                        <h1 className="uk-heading-medium uk-text-bold uk-margin-remove">
                            Jai International
                        </h1>

                        <p className="uk-text-lead uk-margin-small-top">
                            Jai International provides end-to-end support for foreign investors entering the Kazakh market. From preparing documents for an investor visa to registering a new company or branch, our specialists ensure smooth, compliant setup under Kazakhstan’s business regulations.
                        </p>

                        <p>
                            Kazakhstan offers one of Central Asia’s most stable and open economies for international business. Through Jai International, investors can obtain the appropriate visa category, open corporate bank accounts, and secure a legal business address within a matter of weeks.
                        </p>

                        <p>
                            Our agency also provides advisory services on taxation, import–export regulations, and staffing procedures. Whether establishing a new enterprise or expanding an existing one, Jai International ensures that every aspect meets governmental and operational standards.
                        </p>

                        <VisaServicesPromotion />
                    </div>

                    {/* Блок с картинками */}
                    <OnePlusTwoGallery
                        BigImageLink="https://t4.ftcdn.net/jpg/01/34/51/81/360_F_134518160_5DyP0y6YqXQgG6FdorIvpk7M6CBNrglm.jpg"
                        BigImageDescription="Obtain an International Investor's Visa with Jai International"
                        SmallImage1Link="https://tengrinews.kz/userdata/images/u344/resized/2617e0a299611fe826d7393134f312cf.jpg"
                        SmallImage1Description="Nigerian business owner in Almaty city"
                        SmallImage2Link="https://sputnik.kz/img/07e8/0c/13/49402515_0:16:1280:736_1920x0_80_0_0_eeece0f426ceab611e69549efda21506.jpg"
                        SmallImage2Description="Six new african companies have registered their branches in Astana"
                    />

                </section>

                {/* Service Stages Section */}
                <div className="uk-section uk-section-default">
                    <div className="uk-container">
                        <h3 className="uk-text-center">
                            Investor Visa Steps & Guidelines
                        </h3>
                        <p className="uk-text-center uk-text-lead uk-margin-medium-bottom">
                            {t("infopages.services.travel.stages")}
                        </p>

                        <div className="uk-grid-match uk-child-width-1-3@m uk-child-width-1-2@s" uk-grid="true">
                            <div>
                                <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                    <div className="uk-card-badge uk-label uk-label-success">Stage 1</div>
                                    <h4 className="uk-margin-small-top uk-text-bold">Consultation & Document Preparation</h4>
                                    <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                        Collection of investor passport copy, business plan, and company details. Initial service fee of $300 starts the preparation of visa and company registration documents in accordance with Kazakh business law.
                                    </p>
                                </div>
                            </div>

                            <div>
                                <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                    <div className="uk-card-badge uk-label uk-label-warning">Stage 2</div>
                                    <h4 className="uk-margin-small-top uk-text-bold">Visa Processing & Company Registration</h4>
                                    <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                        Submission of investor visa application and corporate registration forms to official authorities. Upon pre-approval, the remaining service balance is paid to complete visa issuance and company setup.
                                    </p>
                                </div>
                            </div>

                            <div>
                                <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                    <div className="uk-card-badge uk-label uk-label-danger">Stage 3</div>
                                    <h4 className="uk-margin-small-top uk-text-bold">Finalisation & Launch Support</h4>
                                    <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                        Delivery of investor visa, company registration certificate, and post-registration guidance. Jai International provides assistance with bank account opening and operational setup for newly established entities.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <FooterSection />
        </>
    );
}

export default OpenCompanyVisaPage;
